/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
/* eslint-disable default-case */

import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import cx from "classnames";
import i18n from "i18n";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React, { useEffect, useRef } from "react";
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import userStatusActions from "../redux/actions/userStatusActions.js";
import Sidebar from "../components/Sidebar/Sidebar.js";
import { useFAibrikContext } from "../context/Context";
import FirstConnexion from "../pages/FirstConnexion/FirstConnexion";
import { useAuth0 } from "../react-auth0-wrapper";
import assistantconfigActions from "../redux/actions/assistantconfigActions";
import assistantsActions from "../redux/actions/assistantsActions.js";
import cockpitActions from "../redux/actions/cockpitActions";
import engageActions from "../redux/actions/engageActions.js";
import routesActions from "../redux/actions/routesActions.js";
import selectedAssistantActions from "../redux/actions/selectedAssistantActions";
import routes from "../routes/routes";
import faibrik_white from "../assets/img/logo/default/faibrik_white.png";
import C from "constants/cockpit";
import L from "constants/labels";
import lod_ from "lodash";

import { getCockpitSelector } from "redux/selectors/cockpitSelectors.js";
import { initAnswers } from "redux/reducers/answersReducers.js";
import { initFilters } from "redux/reducers/filtersReducers.js";
import SelectAssistant from "./SelectAssistant/SelectAssistant.js";
import Cookies from "universal-cookie";
import LoginMenu from "components/Sidebar/LoginMenu.js";
const cookies = new Cookies();

import NewsPage from "./News/index.js";
import SnackBarMessage from "components/SnackBar/index.js";
import VacationModeDialog from "./Cockpit/CockpitDialog/VacationModeDialog.js";

var ps;

const useStyles = makeStyles(styles);

function Dashboard(props) {
	const { isAuthenticated, user, getTokenSilently } = useAuth0();
	const { ...rest } = props;
	const error = useSelector(state => state.error);
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [miniActive, setMiniActive] = React.useState(true);
	const [color] = React.useState("blue");
	const [bgColor] = React.useState("black");
	const [logo] = React.useState(faibrik_white);
	const [firstConnexion, setFirstConnexion] = React.useState(undefined);
	const [surname, setSurname] = React.useState(undefined);
	const [name, setName] = React.useState(undefined);
	const { fAibrikStatus } = useFAibrikContext();
	const userConnected = props.userStatus && props.userStatus.auth && props.userStatus.auth.user;
	const dispatch = useDispatch();
	const { selectedAssistantID } = useSelector(getCockpitSelector, shallowEqual);

	// styles
	const classes = useStyles();
	const mainPanelClasses = lod_.isNil(selectedAssistantID)
		? classes.mainPanel
		: classes.mainPanel +
			" " +
			cx({
				[classes.mainPanelSidebarMini]: miniActive,
				[classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
			});

	const mainPanel = React.createRef();
	const prevAssistantIDRef = useRef();

	/**
	 * RESET STORE
	 */
	useEffect(() => {
		if (prevAssistantIDRef.current) {
			dispatch({ type: C.RESET_COCKPIT });
			dispatch({ type: "ws/reset" });
			//dispatch({ type: UG.RESET_USERGROUP }); //need a cleanup in the project before we can do that
			//dispatch({ type: US.RESET_USERSTATUS });
			dispatch({ type: L.RESET_LABELS });
			dispatch(initAnswers());
			dispatch(initFilters());
		}
		prevAssistantIDRef.current = selectedAssistantID;
	}, [selectedAssistantID]);

	React.useEffect(() => {
		if (firstConnexion !== undefined && !firstConnexion && !lod_.isNil(selectedAssistantID)) {
			if (navigator.platform.indexOf("Win") > -1) {
				ps = new PerfectScrollbar(mainPanel.current, {
					suppressScrollX: true,
					suppressScrollY: false
				});
				if (document?.body?.style) document.body.style.overflow = "hidden";
			}
			window.addEventListener("resize", resizeFunction);
			// Specify how to clean up after this effect:
			return function cleanup() {
				if (navigator.platform.indexOf("Win") > -1) {
					ps.destroy();
				}
				window.removeEventListener("resize", resizeFunction);
			};
		}
	});

	/*
    userStatus initialization (accountID, token, perms)
  */
	React.useEffect(() => {
		if (isAuthenticated && user) {
			if (!user.token) {
				getTokenSilently()
					.then(token => {
						user.token = token;
					})
					/*eslint-disable-next-line no-unused-vars*/
					.then(_ => {
						if (!user.accountID) {
							const urlAssistantID = new URLSearchParams(window.location.search).get("assistantID");
							const initAssistantID = !lod_.isEmpty(urlAssistantID)
								? urlAssistantID
								: selectedAssistantID;
							fAibrikStatus.fetching(user, initAssistantID, (firstConnexion, name, surname) => {
								setFirstConnexion(firstConnexion);
								setName(name);
								setSurname(surname);
							});
						}
					});
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuthenticated, user]);

	////////////////////////////////////////////////////////////////////////////////

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	const resizeFunction = () => {
		if (window.innerWidth >= 960) {
			setMobileOpen(false);
		}
	};

	const passwordChanged = () => {
		setFirstConnexion(false);
	};

	/**
	 * Display name active route on top left like Cockpit,Answer ...etc. otherwise display Default
	 * @param {*} routes
	 * @returns
	 */
	const getActiveRoute = routes => {
		let activeRoute = "Default";
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveRoute = getActiveRoute(routes[i].views);

				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					return `${i18n.t(routes[i].name)}`;
				}
			}
		}
		return activeRoute;
	};

	const handleClickOpen = assistantID => {
		fAibrikStatus.fetching(user, assistantID, (firstConnexion, name, surname) => {
			setFirstConnexion(firstConnexion);
			setName(name);
			setSurname(surname);
		});
	};

	const location = useLocation();
	const url = new URLSearchParams(location.search);

	/**
	 * check if there is a sub-array for one of the arrays, we apply the function recursively otherwise we display the array
	 */

	const getRoutes = (
		<Switch>
			{lod_.isNil(cookies.get("fAIbrik.selectedAssistantID", { path: "/" })) &&
			lod_.isNil(selectedAssistantID) &&
			lod_.isEmpty(url.get("assistantID")) ? (
				<>
					<Route
						exact
						path="/admin/login"
						render={() => {
							return (
								<SelectAssistant handleClickOpen={assistantID => handleClickOpen(assistantID)} />
							);
						}}
						key="login"
					/>
					<Redirect from="/" to="/admin/login" />
					{/* <Route path="/" render={() => <Redirect to="/admin/login" />} /> */}
				</>
			) : (
				<>
					{/* News route */}
					<Route
						path="/admin/news"
						exact
						render={routerProps => {
							return <NewsPage {...routerProps} />;
						}}
					/>
					{routes.map((prop, key) => {
						if (prop.collapse) {
							return prop.views.map((prop, key) => {
								return (
									<Route
										path={prop.layout + prop.path}
										render={routerProps => {
											return <prop.component {...routerProps} />;
										}}
										key={key}
									/>
								);
							});
						} else {
							return (
								<>
									<Route
										path={prop.layout + prop.path}
										render={routerProps => {
											return <prop.component {...routerProps} />;
										}}
										key={key}
									/>
								</>
							);
						}
					})}
					<Route
						path="/"
						render={({ location }) =>
							location.search.includes("conversation") ? (
								<Redirect to={`/admin/cockpit${location.search}`} />
							) : (
								<Redirect to="/admin/cockpit" />
							)
						}
					/>
				</>
			)}
		</Switch>
	);

	return (
		<div className={classes.wrapper} style={{ position: "relative", overflow: "auto" }}>
			<SnackBarMessage />
			{isAuthenticated && firstConnexion !== undefined && !firstConnexion && userConnected && (
				<VacationModeDialog />
			)}
			{error && error.disconnect && (
				<div>
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "white",
							opacity: 0.8,
							zIndex: 999,
							position: "absolute"
						}}
					></div>
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "transparent",
							zIndex: 999,
							position: "absolute"
						}}
					>
						<Snackbar open={true} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
							<Alert severity={error.severity} elevation={6} variant="filled">
								{error.message}
							</Alert>
						</Snackbar>
					</div>
				</div>
			)}

			{isAuthenticated && firstConnexion !== undefined && userConnected && (
				<div style={{ position: "relative", zIndex: 1 }}>
					{firstConnexion ? (
						<FirstConnexion name={name} surname={surname} passwordChanged={passwordChanged} />
					) : (
						<React.Fragment>
							{!lod_.isNil(selectedAssistantID) ? (
								<Sidebar
									logoText={"FAIbrik"}
									logo={logo}
									image={null}
									handleDrawerToggle={handleDrawerToggle}
									open={mobileOpen}
									color={color}
									bgColor={bgColor}
									miniActive={miniActive}
									brandText={getActiveRoute(routes)}
									{...rest}
								/>
							) : (
								<LoginMenu />
							)}

							<div className={mainPanelClasses} ref={mainPanel}>
								<div className={classes.content}>
									<div className={classes.container}>{getRoutes}</div>
								</div>
							</div>
						</React.Fragment>
					)}
				</div>
			)}
		</div>
	);
}

function mapStateToProps(state) {
	return state;
}

function mapDispatchToProps(dispatch) {
	return {
		assistantsActions: bindActionCreators(assistantsActions, dispatch),
		userStatusActions: bindActionCreators(userStatusActions, dispatch),
		selectedAssistantActions: bindActionCreators(selectedAssistantActions, dispatch),
		cockpitActions: bindActionCreators(cockpitActions, dispatch),
		routesActions: bindActionCreators(routesActions, dispatch),
		engageActions: bindActionCreators(engageActions, dispatch),
		assistantconfigActions: bindActionCreators(assistantconfigActions, dispatch)
	};
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Dashboard);
